import styled from 'styled-components';

export const ListContainer = styled.ul`
  display: list-item;
`;
export const BulletItem = styled.li`
  list-style: disc inside none;
`;
